<template>
  <!-- <div>
    <div v-if="isFilterApplied" class="d-flex justify-content-end mb-3">
      <a
        href="javascript:;"
        class="btn btn-secondary w-60 display-6"
        @click="handleClearFilters"
      >
        Clear Filters
      </a>
    </div>
  </div> -->
  <form @submit.prevent="handleFilters">
    <div class="row filter-row mb-3">
      <div class="col-sm-6 col-md-2">
        <div class="input-block mt-1 mb-0">
          <label class="filter-label">Employee ID</label>
          <input
            type="text"
            class="form-control filter-input"
            v-model="filters.employee_id"
          />
        </div>
      </div>
      <div class="col-sm-6 col-md-2">
        <div class="input-block mt-1 mb-0">
          <label class="filter-label">Employee Name</label>
          <input
            type="text"
            class="form-control filter-input"
            v-model="filters.employee_name"
          />
        </div>
      </div>
      <div class="col-sm-6 col-md-2" v-if="showDate">
        <div class="input-block mt-1 mb-0">
          <label class="filter-label">From Date</label>
          <input
            type="date"
            class="form-control filter-input"
            :style="`${
              filters.from_date &&
              'border-bottom: var(--primary-color) 2px solid; border-radius: 6px;'
            }`"
            v-model="filters.from_date"
          />
        </div>
      </div>
      <div class="col-sm-6 col-md-2" v-if="showDate">
        <div class="input-block mt-1 mb-0">
          <label class="filter-label">To Date</label>
          <input
            type="date"
            class="form-control filter-input"
            :style="`${
              filters.to_date &&
              'border-bottom: var(--primary-color) 2px solid; border-radius: 6px;'
            }`"
            v-model="filters.to_date"
            :min="filters.from_date || null"
          />
        </div>
      </div>
      <div v-if="isRaise" class="col-sm-6 col-md-2">
        <div class="input-block mt-1 mb-0">
          <div class="filter-label-row">
            <label class="filter-label">Status</label>
            <i
              v-if="filters.status"
              @click="handleClearOneFilter('status')"
              class="fa-solid fa-xmark filter-clear-icon"
            ></i>
          </div>
          <vue-select :sort="false"
            :options="statuses"
            v-model="filters.status"
            placeholder="Select Status"
            id="design3"
          />
        </div>
      </div>
      <div class="d-flex align-items-end col-sm-6 col-md-3 gap-2 mt-1">
        <button
          type="submit"
          class="btn btn-filter"
          @click.prevent="handleFilters"
        >
          <i class="fa-solid fa-filter me-1"></i> Search
        </button>
        <button
          type="button"
          class="btn btn-reset"
          @click.prevent="resetAllFilters"
        >
          <i class="fa-solid fa-rotate-left me-1"></i> Reset
        </button>
      </div>
    </div>
  </form>
</template>

<script>
import { boolean } from 'yup';

export default {
  props: {
    showDate: {
      type: boolean,
      default: false,
    },
    isRaise: {
      type: boolean,
      default: false,
    }
  },
  data() {
    return {
      select2: null,
      filters: {
        employee_id: "",
        employee_name: "",
        status: "",
        from_date: "",
        to_date: "",
      },
      statuses: ['Approved', 'Pending', 'Rejected'],
      searched: false,
    };
  },
  methods: {
    handleFilters(value) {
      //console.log(JSON.stringify(this.filters));
      this.searched = true;
      const cleanedFilters = Object.fromEntries(
        Object.entries(this.filters).filter(([key, value]) => value !== "")
      );
      this.$emit("apply-filters", cleanedFilters);
      // Perform any action on change
    },

    handleClearOneFilter(fileName) {
      this.filters[fileName] = "";
      const filtersHasProperty = Object.values(this.filters).filter(
        (el) => !!el
      ).length;
      if (this.searched) {
        this.$emit("apply-filters", this.filters);
      }
      if (!filtersHasProperty) {
        this.searched = false;
      }
    },

    resetAllFilters() {
      // Reset all filter values to empty strings
      //   Object.keys(this.filters).forEach(key => {
      //     this.filters[key] = "";
      //   });
      this.filters = [];
      // Emit updated filters
      this.$emit("apply-filters", this.filters);

      // Reset search state
      this.searched = false;
    },

    handleClearFilters() {
      this.$emit("apply-filters", {});
      this.filters = {
        employee_id: "",
        employee_name: "",
        status: "",
        from_date: "",
        to_date: "",
      };
      this.searched = false;
    },
  },
  async created() {
    this.searched = false;
  },

  computed: {
    isFilterApplied() {
      const filtersHasProperty = Object.values(this.filters).filter(
        (el) => !!el
      ).length;

      return this.searched && filtersHasProperty;
    },
  },
};
</script>

<style scoped>
.filter-label-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 4px;
}

.filter-label {
  font-size: 12.5px;
  font-weight: 600;
  color: #878787;
  margin: 0 0 4px;
  padding: 0;
}

.filter-label-row .filter-label {
  margin: 0;
}

.filter-clear-icon {
  font-size: 10px;
  color: #8c9bb5;
  cursor: pointer;
  transition: color 0.2s ease;
}

.filter-clear-icon:hover {
  color: var(--primary-color);
}

:deep(.filter-input) {
  height: 36px;
  border-radius: 6px;
  border: 1px solid #dcdfe6;
  font-size: 12.5px;
  padding: 6px 12px;
  transition: all 0.2s ease;
}

:deep(.filter-input:focus) {
  border-color: var(--primary-color);
  box-shadow: 0 0 0 3px color-mix(in srgb, var(--primary-color) 10%, transparent);
}

:deep(.select2-container--default .select2-selection--single) {
  height: 36px !important;
  border-radius: 6px !important;
  border: 1px solid #dcdfe6 !important;
  transition: all 0.2s ease;
}

:deep(.select2-container--default .select2-selection--single .select2-selection__rendered) {
  font-size: 12.5px !important;
  line-height: 34px !important;
  padding-left: 12px !important;
  padding-right: 30px !important;
}

:deep(.select2-container--default .select2-selection--single .select2-selection__arrow) {
  height: 34px !important;
}

:deep(.select2-container--open .select2-selection--single) {
  border-color: var(--primary-color) !important;
  box-shadow: 0 0 0 3px color-mix(in srgb, var(--primary-color) 10%, transparent);
}

.btn-filter {
  height: 36px;
  padding: 0 14px;
  font-size: 12.5px;
  font-weight: 700;
  border-radius: 6px;
  background-color: var(--primary-color);
  border: 1px solid var(--primary-color);
  color: #ffffff;
  transition: all 0.2s ease;
  cursor: pointer;
}

.btn-filter:hover {
  background-color: color-mix(in srgb, var(--primary-color) 90%, #000);
  border-color: color-mix(in srgb, var(--primary-color) 90%, #000);
  color: #ffffff;
}

.btn-reset {
  height: 36px;
  padding: 0 14px;
  font-size: 12.5px;
  font-weight: 700;
  border-radius: 6px;
  background-color: #ffffff;
  border: 1px solid #dcdfe6;
  color: #606266;
  transition: all 0.2s ease;
  cursor: pointer;
}

.btn-reset:hover {
  background-color: #f5f7fa;
  border-color: #c0c4cc;
  color: #303133;
}
</style>
